import React from 'react';
import { useReveal, JoinBlock, FAQ, PageHeader } from '../components/shared';
import { IMAGES, FAQ_ROADTRIP } from '../mock';

export default function Roadtrip({ go }) {
  useReveal([]);
  return (
    <div className="page active">
      <PageHeader eyebrow="Surf Coast Victoria" title="On Your Way Through Torquay" sub="The first flower farm on the Great Ocean Road" />

      <div className="seo-intro">
        <p className="rev" style={{ maxWidth: 640, margin: '32px auto 0', textAlign: 'center', fontSize: 15, lineHeight: 1.9, color: 'var(--mid)' }}>Torquay is where the Great Ocean Road actually begins — and we're a two-minute detour off it. If you're passing through, here's how to make ten minutes into an hour well spent.</p>
      </div>

      <div className="split">
        <div className="split-photo bg-photo" style={{ backgroundImage: `url(${IMAGES.farmGate})` }} />
        <div className="split-copy">
          <span className="eyebrow rev">Stop One</span>
          <h2 className="rev" style={{ fontFamily: "'Jost',sans-serif", fontWeight: 800, fontSize: 40, color: 'var(--ink)', lineHeight: 1.05, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 20 }}>The Farm Gate.</h2>
          <p className="body-text rev">We're a home-based farm in our very first year, so we're not set up for public visits yet — but when the paddock allows, fresh dahlias, cosmos and ranunculus are available at the farm gate. Follow along to catch it.</p>
          <div className="rev" style={{ marginTop: 8 }}><button className="btn btn-outline" onClick={() => go('home', { scrollToFlowers: true })}>Farm Gate Details</button></div>
        </div>
      </div>

      <div className="split">
        <div className="split-copy" style={{ order: 1 }}>
          <span className="eyebrow rev">Stop Two</span>
          <h2 className="rev" style={{ fontFamily: "'Jost',sans-serif", fontWeight: 800, fontSize: 40, color: 'var(--ink)', lineHeight: 1.05, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 20 }}>Coffee, Five Minutes Away.</h2>
          <p className="body-text rev">Torquay's main strip has no shortage of good coffee within walking distance of the farm gate — grab one, wander the paddock, and you've got a proper start to the day before Bells Beach is even in view.</p>
        </div>
        <div className="split-photo bg-photo" style={{ order: 2, backgroundImage: `url(${IMAGES.lemonField})` }} />
      </div>

      <div className="split">
        <div className="split-photo bg-photo" style={{ backgroundImage: `url(${IMAGES.goldenField})` }} />
        <div className="split-copy">
          <span className="eyebrow rev">Stop Three</span>
          <h2 className="rev" style={{ fontFamily: "'Jost',sans-serif", fontWeight: 800, fontSize: 40, color: 'var(--ink)', lineHeight: 1.05, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 20 }}>Point Danger Lookout.</h2>
          <p className="body-text rev">A short drive from the farm — one of the best free views on the whole Surf Coast, and the actual start line of the Great Ocean Road itself. Good spot for the photo you're about to send everyone.</p>
        </div>
      </div>

      <FAQ items={FAQ_ROADTRIP} title="Planning the Detour" eyebrow="Good to Know" />

      <JoinBlock eyebrow="Passing Through Again?" headline="Join our community.<br>Know before you go." body="Farm stand updates, what's blooming, and pick-your-own dates — so next time you're on the Great Ocean Road, you'll know exactly when to stop." />
    </div>
  );
}
